export enum AuthenticationMethod {
  External = "password",
  Capgemini = "microsoft.com",
}
